import { ActionType, getType } from 'typesafe-actions';
import { PlatformActions } from './PlatformActions';
import { IGameState } from './IGameState';
import { hidePrioPopup, showPrioPopup } from '../UI/UIStateHelper';
import Game from '../../Game';
import {
    PLATFORM_ERROR_CODES,
    PlatformErrorCode,
} from '../../Constants/Platform';
import { Reducer } from 'redux';
import { SignInState } from './SignInState';

export const PlatformReducer: Reducer<IGameState> = (
    state: IGameState,
    action: ActionType<typeof PlatformActions>
) => {
    switch (action.type) {
        case getType(PlatformActions.signOutPrompt):
            return {
                ...state,
                UIStatePrio: showPrioPopup(state.UIStatePrio, 'confirmMenu', {
                    title: Game.locale.getText('Warning'),
                    body: Game.locale.getText('ConfirmSignOut'),
                }),
            };
        case getType(PlatformActions.setSignInState):
            return {
                ...state,
                platform: {
                    ...state.platform,
                    signInState: action.payload,
                },
                UIStatePrio: hidePrioPopup(
                    state.UIStatePrio,
                    'confirmMenu',
                    {}
                ),
            };
        case getType(PlatformActions.signInFail):
            if (action.payload !== PlatformErrorCode.NONE) {
                const messageLocaleKey = PLATFORM_ERROR_CODES[action.payload];
                return {
                    ...state,
                    platform: {
                        ...state.platform,
                        signInState: SignInState.SignedOut,
                    },
                    UIStatePrio: showPrioPopup(state.UIStatePrio, 'errorMenu', {
                        title: Game.locale.getText('Warning'),
                        body: Game.locale.getText(messageLocaleKey),
                    }),
                };
            }
            return {
                ...state,
                platform: {
                    ...state.platform,
                    signInState: SignInState.SignedOut,
                },
            };
        case getType(PlatformActions.signInSuccess):
            return {
                ...state,
                platform: {
                    ...state.platform,
                    signInState: SignInState.SignedIn,
                },
            };
        default:
            return state;
    }
};
